// 爱心档位已改为仅使用接口 /api/drip-plan/public/packages 动态数据，此处不再保留静态档位

export const targetGroups = [
  {
    id: 1,
    name: '南岸区环卫工人团队',
    category: '环卫工人',
    location: '南岸区',
    members: 156,
    description: '主要负责南岸区主城区道路清扫保洁工作,工作时间为凌晨4点至晚上8点。',
  },
  {
    id: 2,
    name: '渝北区快递配送站',
    category: '快递员',
    location: '渝北区',
    members: 89,
    description: '服务渝北区及周边区域的快递配送,日均配送量超过5000件。',
  },
  {
    id: 3,
    name: '江北区建筑工地联合会',
    category: '建筑工人',
    location: '江北区',
    members: 234,
    description: '涵盖江北区12个在建工地的建筑工人,主要从事高空作业和重体力劳动。',
  },
  {
    id: 4,
    name: '渝中区交通协管队',
    category: '交通协管',
    location: '渝中区',
    members: 67,
    description: '负责渝中区主要路口的交通疏导和秩序维护工作。',
  },
  {
    id: 5,
    name: '巴南区外卖骑手联盟',
    category: '外卖骑手',
    location: '巴南区',
    members: 112,
    description: '服务巴南区的外卖配送,日均配送订单超过3000单。',
  },
];

export const faqData = [
  {
    question: '捐赠的钱都用在哪里了?',
    answer: '您的每一笔捐款都会100%用于采购优质矿泉水和配送服务。我们承诺不从捐款中提取任何管理费用,所有运营成本由合作企业赞助。您可以在"公益公示"页面查看详细的资金使用明细。',
  },
  {
    question: '如何确保水送到了真正需要的人手中?',
    answer: '我们建立了完善的配送和监督机制:1)与受助单位签订协议确认需求;2)志愿者现场配送并拍照记录;3)受助者签收确认;4)所有配送记录在官网公示。您可以通过捐赠编号查询您的爱心去向。',
  },
  {
    question: '可以申请捐赠票据吗?',
    answer: '可以。捐赠成功后,您可以在感恩证书页面点击"申请票据"按钮,填写相关信息。我们会在5个工作日内为您开具由重庆市南岸区慈善会出具的公益捐赠票据,可用于个人所得税抵扣。',
  },
  {
    question: '定向捐赠是什么意思?',
    answer: '定向捐赠是指您可以选择将爱心捐赠给特定的群体或区域,比如"南岸区环卫工人"或"渝北区快递员"。我们会确保您的捐款精准送达指定对象。如果不选择定向,我们会根据实际需求统筹分配。',
  },
  {
    question: '企业可以参与捐赠吗?',
    answer: '当然可以!我们非常欢迎企业参与。企业捐赠可以选择冠名捐赠、定向捐赠等多种方式,我们会为企业提供专属的公益报告和宣传支持。详情请联系我们的企业合作部门:400-123-4567。',
  },
];
